import * as React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
} from "@material-ui/core";
import { useDataProvider } from "ra-core";

export default () => {
  const dataProvider = useDataProvider();
  const [totalUsers, setTotalUsers] = React.useState(0);
  const [totalContactMessages, setTotalContactMessages] = React.useState(0);
  const [totalReadContactMessages, setTotalReadContactMessages] =
    React.useState(0);
  const [totalUnreadContactMessages, setTotalUnreadContactMessages] =
    React.useState(0);

  const [totalTanks, setTotalTanks] = React.useState(0);
  const [totalBrands, setTotalBrands] = React.useState(0);
  const [totalProducts, setTotalProducts] = React.useState(0);
  const [totalPlaces, setTotalPlaces] = React.useState(0);
  const [totalProductOrders, setTotalProductOrders] = React.useState(0);

  const [totalTransferOrders, setTotalTransferOrders] = React.useState(0);
  const [totalApprovedTransferOrders, setTotalApprovedTransferOrders] =
    React.useState(0);
  const [totalRefusedTransferOrders, setTotalRefusedTransferOrders] =
    React.useState(0);
  const [totalPendingTransferOrders, setTotalPendingTransferOrders] =
    React.useState(0);

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState();

  React.useEffect(() => {
    dataProvider
      .getList("users", {
        pagination: { page: 1, perPage: 1 },
      })
      .then(({ total }) => {
        setTotalUsers(total);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    dataProvider
      .getList("contactMessages", {
        pagination: { page: 1, perPage: 1000000 },
      })
      .then(({ total, data }) => {
        setTotalContactMessages(total);
        data.forEach((item) => {
          if (item.read) {
            setTotalReadContactMessages((old) => old + 1);
          } else {
            setTotalUnreadContactMessages((old) => old + 1);
          }
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    dataProvider
      .getList("tanks", {
        pagination: { page: 1, perPage: 1 },
      })
      .then(({ total }) => {
        setTotalTanks(total);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    dataProvider
      .getList("brands", {
        pagination: { page: 1, perPage: 1 },
      })
      .then(({ total }) => {
        setTotalBrands(total);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    dataProvider
      .getList("products", {
        pagination: { page: 1, perPage: 1 },
      })
      .then(({ total }) => {
        setTotalProducts(total);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    dataProvider
      .getList("places", {
        pagination: { page: 1, perPage: 1 },
      })
      .then(({ total }) => {
        setTotalPlaces(total);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    dataProvider
      .getList("productOrders", {
        pagination: { page: 1, perPage: 1 },
      })
      .then(({ total }) => {
        setTotalProductOrders(total);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });

    dataProvider
      .getList("transferOrders", {
        pagination: { page: 1, perPage: 10000000 },
      })
      .then(({ total, data }) => {
        setTotalTransferOrders(total);
        data.forEach((item) => {
          if (item.status === "DONE") {
            setTotalApprovedTransferOrders((old) => old + 1);
          } else if (item.status === "REFUSED") {
            setTotalRefusedTransferOrders((old) => old + 1);
          } else if (item.status === "PENDING") {
            setTotalPendingTransferOrders((old) => old + 1);
          }
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <Card>
        <CardHeader title="Welcome to AmaCoin Dashboard" />
        <CardContent>Amacoin statistics in a glance</CardContent>
      </Card>
      <div style={{ marginTop: 10 }}>
        <Grid container spacing={2} style={{ width: "100%" }}>
          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#262626" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Total Users" style={{ color: "#fff" }} />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>{totalUsers}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#EEBC29" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Total Messages" style={{ color: "#000" }} />
                <CardContent>
                  <h1 style={{ color: "#000" }}>{totalContactMessages}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#262626" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Total Tanks" style={{ color: "#fff" }} />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>{totalTanks}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#EEBC29" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Total Brands" style={{ color: "#000" }} />
                <CardContent>
                  <h1 style={{ color: "#000" }}>{totalBrands}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#262626" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Total Products" style={{ color: "#fff" }} />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>{totalProducts}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#EEBC29" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Total Places" style={{ color: "#000" }} />
                <CardContent>
                  <h1 style={{ color: "#000" }}>{totalPlaces}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#262626" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader
                  title="Total Product Orders"
                  style={{ color: "#fff" }}
                />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>{totalProductOrders}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Card style={{ backgroundColor: "#EEBC29" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader
                  title="Total Transfer Orders"
                  style={{ color: "#000" }}
                />
                <CardContent>
                  <h1 style={{ color: "#000" }}>{totalTransferOrders}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>

      {/* Transfer Orders */}
      <div style={{ marginTop: 40 }}>
        <h1>Transfer Orders</h1>
        <Grid container spacing={2} style={{ width: "100%" }}>
          <Grid item xs={12} sm={4}>
            <Card style={{ backgroundColor: "#198754" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader
                  title="Approved Transfer Orders"
                  style={{ color: "#fff" }}
                />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>
                    {totalApprovedTransferOrders}
                  </h1>
                </CardContent>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card style={{ backgroundColor: "#dc3545" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader
                  title="Refused Transfer Orders"
                  style={{ color: "#fff" }}
                />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>
                    {totalRefusedTransferOrders}
                  </h1>
                </CardContent>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card style={{ backgroundColor: "#F29339" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader
                  title="Pending Transfer Orders"
                  style={{ color: "#fff" }}
                />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>
                    {totalPendingTransferOrders}
                  </h1>
                </CardContent>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>

      {/* Contact Messages */}
      <div style={{ marginTop: 40 }}>
        <h1>Messages</h1>
        <Grid container spacing={2} style={{ width: "100%" }}>
          <Grid item xs={12} sm={4}>
            <Card style={{ backgroundColor: "#0d6efd" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Total Messages" style={{ color: "#fff" }} />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>{totalContactMessages}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card style={{ backgroundColor: "#198754" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Read Messages" style={{ color: "#fff" }} />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>{totalReadContactMessages}</h1>
                </CardContent>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card style={{ backgroundColor: "#F29339" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CardHeader title="Unread Messages" style={{ color: "#fff" }} />
                <CardContent>
                  <h1 style={{ color: "#fff" }}>
                    {totalUnreadContactMessages}
                  </h1>
                </CardContent>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
